import { addClass } from '../add-class';

export function addClassFactory(className: string) {
	return (element: Element) => addClass(element, className);
}
